export const sortByDate = (a, b) => {
  const dateA = new Date(a);
  const dateB = new Date(b);
  if (dateA < dateB) return -1;
  if (dateA > dateB) return 1;
  return 0;
};

export function dynamicSort(props, desc) {
  return function (a, b) {
    for (let i = 0; i < props.length; i++) {
      const propName = props[i];
      const order = desc[i] === true ? -1 : 1;

      const aValue = a[propName];
      const bValue = b[propName];

      let comparison = 0;
      if (!isNaN(new Date(aValue)) && !isNaN(new Date(bValue))) {
        comparison = sortByDate(aValue, bValue);
      } else if (typeof aValue === "string" && typeof bValue === "string") {
        comparison = aValue.localeCompare(bValue);
      } else if (typeof aValue === "number" && typeof bValue === "number") {
        comparison = aValue - bValue;
      } else {
        if (aValue < bValue) comparison = -1;
        else if (aValue > bValue) comparison = 1;
      }

      if (comparison !== 0) {
        return comparison * order;
      }
    }
    return 0;
  };
}
